import { injectIntl } from "react-intl";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { formatNumber } from "src/helpers/formatNumber";

const RevenueByList = ({ data = [], totalRevenue = 0 }) => {
  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardNarrow">
      <div className="SmsAnalyticsChartTitle">Revenue by List</div>
      <div className="SmsAnalyticsDonutWrapper">
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={65}
              outerRadius={90}
              dataKey="value"
              paddingAngle={4}
              stroke="#fff"
              strokeWidth={2}
            >
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="SmsAnalyticsDonutCenter">
          <div className="SmsAnalyticsDonutCenterLabel">Total</div>
          <div className="SmsAnalyticsDonutCenterValue">
            ${formatNumber(totalRevenue)}
          </div>
        </div>
      </div>
      <div className="SmsAnalyticsDonutLegend">
        {data.map((item) => (
          <div key={item.name} className="SmsAnalyticsDonutLegendItem">
            <span
              className="SmsAnalyticsLegendDot"
              style={{ backgroundColor: item.color }}
            />
            <div className="SmsAnalyticsDonutLegendText">
              <span className="SmsAnalyticsDonutLegendName">{item.name}</span>
              <span className="SmsAnalyticsDonutLegendPercent">
                {formatNumber(item.percent)}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default injectIntl(RevenueByList);
